import { tss } from 'tss-react/mui';

export const useStyles = tss.withName('LayoutHeaderResponsiveNavTablet').create(() => ({
  paperRoot: {
    right: 0,
    borderTop: 0
  }
}));
